export default __webpack_public_path__ + "static/security_b.60307b1aed8fe12873248e0c5d532d19.png";